export default __webpack_public_path__ + "static/media/cancelado.c7ba27cb.svg";